import { ImagePlus } from 'lucide-react'

interface ImagePickerButtonProps {
  imageUrl: string | null
  onClick: () => void
  emptyStateHint?: string
}

export function ImagePickerButton({ imageUrl, onClick, emptyStateHint }: ImagePickerButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group/img relative flex h-40 w-full items-center justify-center rounded-lg border-2 border-dashed border-line bg-bg-3 transition-colors hover:border-acid/50 hover:bg-bg-4"
    >
      {imageUrl ? (
        <>
          <img src={imageUrl} alt="" className="h-full w-full rounded-lg object-cover" />
          <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-black/0 transition-colors group-hover/img:bg-black/30">
            <span className="rounded-md border border-line-bright bg-bg-2/90 px-2.5 py-1 text-[11px] font-medium text-paper opacity-0 shadow-sm transition-opacity group-hover/img:opacity-100">
              Change image
            </span>
          </div>
        </>
      ) : (
        <div className="flex flex-col items-center gap-1.5">
          <ImagePlus size={20} className="text-paper-faint" />
          <span className="text-[11px] text-paper-faint">Choose image</span>
          {emptyStateHint && <span className="text-[10px] text-paper-faint">{emptyStateHint}</span>}
        </div>
      )}
    </button>
  )
}
